import { render, staticRenderFns } from "./FormContent.vue?vue&type=template&id=c8837024&scoped=true&"
import script from "./FormContent.vue?vue&type=script&lang=js&"
export * from "./FormContent.vue?vue&type=script&lang=js&"
import style0 from "./FormContent.vue?vue&type=style&index=0&id=c8837024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8837024",
  null
  
)

export default component.exports